import styled from "styled-components";

export const Paragraph = styled.p`
  margin: 0 0 16px;
  line-height: 1.6;
`;

export const Name = styled.strong`
  color: teal;
`;

export const Content = styled.div`
  line-height: 1.6;
`;
